var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-mutable-exports */
/**
 * @module cercaliagl/dictionary
 */
import { LANG } from './globals';
import dictionaryCA from './lang/ca';
import dictionaryDE from './lang/de';
import dictionaryEN from './lang/en';
import dictionaryES from './lang/es';
import dictionaryFR from './lang/fr';
import dictionaryPT from './lang/pt';
export var ready = false;
export var currentDictionaryLanguage = 'es';
/**
 * @type {Object.<string, string>}
 */
var dictionary = {};
/**
 * @param {string} str key
 * @return {string} Translated text
 */
export function i18n(str) {
    return dictionary[str];
}
/**
 * @param {string} lang Lang.
 * @param {boolean=} [force] Force to reload
 * @return {Object.<string, string>} Dictionary
 */
export function createDictionary(lang, force) {
    if (!ready || force) {
        currentDictionaryLanguage = lang;
        switch (lang) {
            case 'ca':
                dictionary = __assign({}, dictionaryCA);
                break;
            case 'de':
                dictionary = dictionaryDE;
                break;
            case 'en':
                dictionary = dictionaryEN;
                break;
            case 'es':
                dictionary = dictionaryES;
                break;
            case 'fr':
                dictionary = dictionaryFR;
                break;
            case 'pt':
                dictionary = dictionaryPT;
                break;
            default:
                currentDictionaryLanguage = 'en';
                dictionary = dictionaryEN;
                break;
        }
        ready = true;
        // Enabling global function for webcomponents
        window.cercalia = window.cercalia || {};
        window.cercalia.getDictionary = window.cercalia.getDictionary || (function () { return dictionary; });
    }
    return dictionary;
}
createDictionary(LANG);
//# sourceMappingURL=dictionary.js.map